// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import appConfig from './config/base.js'
import Http from './common/request'
import { digitalFlop,scrollBoard,waterLevelPond,loading } from '@jiaminghi/data-view'
import { Loading,Popup ,NoticeBar ,Switch,Notify,Dialog,Pagination    } from 'vant';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Vue.use(digitalFlop)
Vue.use(scrollBoard)
Vue.use(waterLevelPond)
Vue.use(Pagination)
Vue.use(loading)
Vue.use(Loading);
window.$http = Http;
Vue.prototype.appConfig = appConfig;

Vue.config.productionTip = false;

// router.beforeEach((to, from, next) => {
//   if (to.path === '/login') {
//     next();
//   } else {
//     let token = localStorage.getItem('token');
//     if (token === null || token === '') {
//       next('/login');
//     } else {
//       next();
//     }
//   }
// });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js